import * as React from "react";
import {getManuscriptAPI} from '../apis'
import {Avatar, Horizontal, Image, Text, Vertical} from "../../../components/index";
import {imageCut} from '../../../components/Image'
import wx from "../../../utils/wxUtils";
import {feedShowCreateTime} from '../../../utils/uiUtils'
import {downloadApp} from "../utils";
import Button from "../../../components/Button";
import {connect} from "react-redux";

class ManuscriptDetailScreen extends React.Component {
    state = {
        loading: true,
        product: null
    };

    constructor() {
        super(...arguments);

        document.title = '手稿详情';
        getManuscriptAPI(this.props.match.params._pid).then(res => {
            if (res.isOk) {
                this.setState({product: res.data.data, loading: false})
            }
        })
    }

    render3Images() {
        const {image_urls} = this.state.product;

        const list = [];

        image_urls.map(image => list.push(<img onClick={() => this.onImageClick(image)}
                                               src={imageCut(image, {width: 100, height: 100})} key={image} style={{
                width: '30%',
                height: '30%',
                marginRight: '2%',
                marginTop: '1%'
            }}/>
        ));
        return list
    }


    onImageClick(current) {
        wx.previewImage({
            current, urls: this.state.product.image_urls
        })
    }

    render2Images() {
        const {image_urls} = this.state.product;

        const list = [];

        image_urls.map(image => list.push(<img onClick={() => this.onImageClick(image)}
                                               src={imageCut(image, {width: 180, height: 180})} key={image} style={{
                width: '48%',
                height: '48%',
                marginRight: '2%',
                marginTop: '1%'
            }}/>
        ));
        return list
    }

    renderImages() {
        const {image_urls} = this.state.product;

        return <Vertical hc vc style={{position: 'relative', height: 230}}>
            <img src={imageCut(image_urls[0], {width: 100})} onClick={() => this.onImageClick(image_urls[0])}
                 style={{width: 230, height: 230}}/>
            <div style={{
                position: 'absolute',
                backgroundSize: 'cover',
                width: 230,
                height: 230,
                top: 0,
                backgroundImage: 'url(' + require('../assets/mask.png') + ')'
            }}/>
        </Vertical>
    }

    toHome = () => {
        // this.props.history.push('/' + this.state.product.userInfo.userId)
    };

    render() {
        if (this.state.loading)
            return this.renderLoading();

        const {userInfo} = this.state.product
        return <Vertical>
            <Vertical className={'portfolio detail'}>

                <Text style={{fontSize: 14, marginBottom: 15}}>手稿原图预览</Text>

                {this.renderImages()}

                {this.state.product.title &&
                <Text style={{
                    color: '#333',
                    fontSize: 14,
                    marginTop: 15,
                    marginBottom: 15
                }}>{this.state.product.title}</Text>}

                {this.renderTags()}

                <Horizontal style={{marginBottom: 10, fontSize: 14}}><Text style={{color: '#666', flex: 1}}>库存数量：<Text
                    style={{color: '#000'}}>{this.state.product.stock}</Text></Text>
                    <Text style={{fontSize: 16, color: '#f73d28'}}><Text
                        style={{fontSize: 10}}>￥</Text>{this.state.product.price}</Text>
                </Horizontal>

                <Horizontal vc>
                    <Horizontal style={{flex: 1, height: 1, background: '#e0e0e0', marginRight: 30}}/><Text
                    style={{color: '#999'}}>2018-01-09</Text>
                </Horizontal>
                <Vertical hc onClick={this.toHome}>
                    <Avatar diameter={65} source={{uri: userInfo.avatar}} style={{marginTop: 10, marginBottom: 10}}/>
                    <Vertical hc>
                        <Horizontal><Text className={'nickname'} style={{marginRight: 10}}>{userInfo.nickname}</Text>
                            {this.props.userInfo.bao ?
                                <div className='biaojiItem'>
                                    <div className={'biaoji bao'}>签约保障</div>
                                </div> :
                                this.props.userInfo.v ?
                                    <div className='biaojiItem'>
                                        <div className={"biaoji shiming"}>实名认证</div>
                                    </div> : 无
                            }
                        </Horizontal>
                        <Text style={{color: '#a9a9a9', fontSize: 12, marginTop: 10}}>© 版权归作者所有，请在购买后使用</Text>
                    </Vertical>
                </Vertical>

                <div dangerouslySetInnerHTML={{__html: this.state.product.content.replace(/\n/g, '<br>')}}
                     style={{color: '#333', lineHeight: '22px', marginTop: 20, fontSize: 14}}/>

                <div style={{
                    width: 50,
                    height: 1,
                    background: '#e0e0e0',
                    marginTop: 15,
                    marginBottom: 10
                }}/>
                <Text style={{
                    fontSize: 14,
                    color: '#999'
                }}>*虚拟电子产品，购买后不得退款</Text>
            </Vertical>

            <div style={{height: 50}}/>
            {this.renderFooter()}
        </Vertical>
    }


    renderFooter() {
        return <Horizontal style={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            height: 50,
            borderTopColor: '#ededed',
            borderTopWidth: 1,
            borderTopStyle: 'solid',
            background: '#fff'
        }}>


            <Horizontal style={{height: 50, flex: 1, color: '#666'}} vc hc onClick={this.toOrder}><Image
                source={require('../assets/ic_collect.png')}
                style={{
                    width: 18,
                    height: 18,
                    marginRight: 8
                }}/>收藏</Horizontal>
            <Button style={{
                background: '#000',
                height: 40,
                color: '#fff',
                borderRadius: 20,
                marginTop: 5,
                fontSize: 14,
                paddingLeft: 30,
                marginRight: 15,
                paddingRight: 30, lineHeight: '38px'
            }}
                    onClick={this.toOrder}>下载高清大图</Button>
        </Horizontal>
    }

    renderDownload() {
        return <div style={{
            textAlign: 'right',
            marginTop: 15,
            color: '#aaa',
            fontSize: 13,
            paddingBottom: 80,
            marginRight: 15
        }}
                    onClick={downloadApp}
        ><span>{feedShowCreateTime(this.state.product.created)}发布于 <span
            style={{color: '#2359a6', textDecoration: 'underline'}}>纹身大咖</span></span>
        </div>
    }

    renderLoading() {
        return <Vertical style={splash.root}>
            <Image source={require('../assets/loading.gif')} style={splash.loading}/>
        </Vertical>
    }

    renderTags() {
        const {tag} = this.state.product;

        return <Horizontal style={{marginBottom: 15}}>
            {tag.split('#').map((tag, i) => <Text
                style={{background: '#000', marginRight: 10, color: '#fff', fontSize: 10, padding: 2}}
                key={i}>{tag}</Text>)}
        </Horizontal>
    }
}

export default connect((state) => {
    return {
        userInfo: state.app.userInfo,
    }
})(ManuscriptDetailScreen);


const splash = {
    root: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff'
    },

    loading: {
        height: 50,
        width: 80
    }
};


// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/ManuscriptDetailScreen.js